<nav class="navbar navbar-light">
    <a class="navbar-brand" href="#">
      <!-- <img src="../assets/logo/gfs-logo.png"  class="d-inline-block align-top" alt=""> -->
      <span class="navbar-brand-title ml-3">Employee Engagement Software - Dundas BI Tenant and ETL Job Manager</span>
    </a>
    <div class="my-2 my-lg-0">
      <span class="navbar-user mr-2"></span>
      <span class="navbar-user mr-2">{{ loggedInUser }}</span> 
     
     <img class="settings" src="../assets/icons/Settings.png" (click)='openSettingModal()'>
    </div>
  </nav>
  